import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, formatApiError } from "../../api";
import { CONTROL } from "../../constants/testIds";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { toast } from "../ui/sonner";

// Owner name/email live on the gym's super_admin user_account; phone/city live on
// organization_profile.contact (see routers/control.py's PATCH /gyms/{id}/owner) -- this panel
// is the one screen that edits both together, same always-editable-inputs pattern as
// BillingEditPanel rather than a separate view/edit toggle.
export function GymOwnerPanel({ orgId, owner, canEdit }) {
  const queryClient = useQueryClient();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");

  useEffect(() => {
    setName(owner?.name || "");
    setEmail(owner?.email || "");
    setPhone(owner?.phone || "");
    setCity(owner?.city || "");
  }, [owner]);

  const mutation = useMutation({
    mutationFn: () => api.patch(`/control/gyms/${orgId}/owner`, {
      name: name || undefined, email: email || undefined, phone: phone || undefined, city: city || undefined,
    }),
    onSuccess: () => {
      toast.success("Owner contact updated.");
      queryClient.invalidateQueries({ queryKey: ["control-gym-detail", orgId] });
    },
    onError: (e) => toast.error(formatApiError(e).message),
  });

  return (
    <div className="solid-surface rounded-[14px] p-5 space-y-3">
      <p className="eyebrow">Contact</p>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Owner name</Label>
          <Input data-testid={CONTROL.gymOwnerNameInput} value={name} onChange={(e) => setName(e.target.value)} disabled={!canEdit} placeholder="Not provided" />
        </div>
        <div className="space-y-1.5">
          <Label>Email</Label>
          <Input type="email" data-testid={CONTROL.gymOwnerEmailInput} value={email} onChange={(e) => setEmail(e.target.value)} disabled={!canEdit} placeholder="Not provided" />
        </div>
        <div className="space-y-1.5">
          <Label>Phone</Label>
          <Input data-testid={CONTROL.gymOwnerPhoneInput} value={phone} onChange={(e) => setPhone(e.target.value)} disabled={!canEdit} placeholder="Not provided" />
        </div>
        <div className="space-y-1.5">
          <Label>City</Label>
          <Input data-testid={CONTROL.gymOwnerCityInput} value={city} onChange={(e) => setCity(e.target.value)} disabled={!canEdit} placeholder="Not provided" />
        </div>
      </div>
      <Button data-testid={CONTROL.gymOwnerSaveButton} disabled={!canEdit || mutation.isPending} onClick={() => mutation.mutate()} className="text-white" style={{ background: "var(--scarlet-accent)" }}>
        Save contact
      </Button>
    </div>
  );
}
